import { apis } from 'ui-common'

export default {
  updateHealthHistory: ({ qPage3Id, info }: any) => apis
    .$put(`/health-histories/${qPage3Id}`, info)
}
